import { h } from 'vue'
import { useModal } from 'bootstrap-vue-next';
import dayjs from 'dayjs';

export const IdNotDefined: number = 0;
export const GuidEmpty: string = '00000000-0000-0000-0000-000000000000';

export function GetTravelTypeLabel(type: TravelDbTypeEnum): string {
  switch (type) {
    case TravelDbTypeEnum.Seminaire: return 'Séminaire';
    case TravelDbTypeEnum.Special: return 'Spécial';
    case TravelDbTypeEnum.Private: return 'Privé';
    case TravelDbTypeEnum.Group: return 'Groupe';
    case TravelDbTypeEnum.Ski: return 'Ski';
    case TravelDbTypeEnum.Benevolat: return 'Bénévolat';
    default: return type;
  }
}

export function GetTitleBannerAlignmentLabel(alignment: TravelDbTitleBannerAlignmentEnum): string {
  switch (alignment) {
    case TravelDbTitleBannerAlignmentEnum.Left: return 'Aligné à gauche';
    case TravelDbTitleBannerAlignmentEnum.Center: return 'Centré';
    case TravelDbTitleBannerAlignmentEnum.Right: return 'Aligné à droite';
    default: return alignment;
  }
}

export function GetInfoFieldTypeLabel(type: TravelDbFieldTypeEnum): string {
  switch (type) {
    case TravelDbFieldTypeEnum.Text: return 'Texte';
    case TravelDbFieldTypeEnum.TextArea: return 'Zone de texte';
    case TravelDbFieldTypeEnum.Number: return 'Nombre';
    case TravelDbFieldTypeEnum.Date: return 'Date';
    case TravelDbFieldTypeEnum.Choice: return 'Choix';
    case TravelDbFieldTypeEnum.Boolean: return 'Oui/Non';
    default: return type;
  }
}

export function GetTransportationTypeLabel(type: TravelDbTransportationTypeEnum): string {
  switch (type) {
    case TravelDbTransportationTypeEnum.Vol: return 'Vol';
    case TravelDbTransportationTypeEnum.Train: return 'Train';
    case TravelDbTransportationTypeEnum.Autocar: return 'Autocar';
    default: return type;
  }
}

export function GetTransferTypeLabel(type: TravelDbTransferTypeEnum): string {
  switch (type) {
    case TravelDbTransferTypeEnum.Bus: return 'Bus';
    case TravelDbTransferTypeEnum.Train: return 'Train';
    case TravelDbTransferTypeEnum.Autocar: return 'Autocar';
    default: return type;
  }
}

export function GetTransferDirectionLabel(type: TravelDbTransferDirectionEnum): string {
  switch (type) {
    case TravelDbTransferDirectionEnum.Outbound: return 'Aller';
    case TravelDbTransferDirectionEnum.Return: return 'Retour';
    case TravelDbTransferDirectionEnum.RoundTrip: return 'Aller-Retour';
    default: return type;
  }
}

export function GetCivilityShortLabel(type?: CivilityEnum): string {
  if (!type) return '';
  switch (type) {
    case CivilityEnum.Mr: return 'Mr';
    case CivilityEnum.Mrs: return 'Mme';
    default: return '';
  }
}

export function GetUserStatusLabel(type?: UserStatusEnum): string {
  switch (type) {
    case undefined: return '';
    case null: return '';
    case UserStatusEnum.Succursale: return 'Succursale';
    case UserStatusEnum.Franchise: return 'Franchisé(e)';
    case UserStatusEnum.Collaborateur: return 'Collaborateur Franchise';
    case UserStatusEnum.DDP_AR: return 'DDP / AR';
    case UserStatusEnum.Siege: return 'Siège';
    case UserStatusEnum.Partenaire: return 'Partenaire';
    case UserStatusEnum.Medecin: return 'Médecin';
    case UserStatusEnum.Organisation: return 'Organisation';
    case UserStatusEnum.Autre: return 'Autre';
    default: return type;
  }
}

export function GetRelationLabel(type: UserRelationEnum): string {
  switch (type) {
    case UserRelationEnum.Conjoint: return 'Conjoint(e)';
    case UserRelationEnum.Collaborateur: return 'Collaborateur(trice)';
    case UserRelationEnum.Enfant: return 'Enfant';
    case UserRelationEnum.Autre: return 'Autre';
    case UserRelationEnum.Adulte: return 'Adulte';
    default: return type;
  }
}

export function GetRelationLabelPrivate(type: UserRelationEnum): string {
  switch (type) {
    case UserRelationEnum.Adulte: return 'Adulte';
    case UserRelationEnum.Enfant: return 'Enfant ( -12 ans )';
    default: return type;
  }
}

export function GetTravelDbDiscountTypeLabel(type: TravelDbDiscountTypeEnum, TTC: boolean): string {
  switch (type) {
    case TravelDbDiscountTypeEnum.Percent: return 'Pourcentage (%)';
    case TravelDbDiscountTypeEnum.Euro: return `Montant (€ ${TTC ? 'TTC' : 'HT'})`;
    default: return type;
  }
}

// Label du type de chambre
export const GetHotelRoomTypeLabelShort = (type: TravelDbHotelRoomTypeEnum): string => {
  switch (type) {
    case TravelDbHotelRoomTypeEnum.Single: return 'Single';
    case TravelDbHotelRoomTypeEnum.Double: return 'Double';
    case TravelDbHotelRoomTypeEnum.Twin: return 'Twin';
    case TravelDbHotelRoomTypeEnum.Famille: return 'Famille';
    default: return type;
  }
};

export function GetHotelRoomTypeLabelLong(type: TravelDbHotelRoomTypeEnum): string {
  switch (type) {
    case TravelDbHotelRoomTypeEnum.Single: return 'Single ( 1 lit )';
    case TravelDbHotelRoomTypeEnum.Double: return 'Double ( 1 lit )';
    case TravelDbHotelRoomTypeEnum.Twin: return 'Twin ( 2 lits )';
    case TravelDbHotelRoomTypeEnum.Famille: return 'Famille';
    default: return type;
  }
}

export function GetDocumentTypeLabel(type: TravelDbDocumentTypeEnum): string {
  switch (type) {
    case TravelDbDocumentTypeEnum.Image: return 'Image';
    case TravelDbDocumentTypeEnum.Pdf: return 'PDF';
    case TravelDbDocumentTypeEnum.Any: return 'Tous types';
    default: return type;
  }
}

export function ScrollToTop() {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

export function ScrollToId(elementId: string) {
  let el = document.getElementById(elementId);
  if (el) {
    el.scrollIntoView({behavior: 'smooth'});
  }
  else {
    setTimeout(() => {
      el = document.getElementById(elementId);
      el?.scrollIntoView({behavior: 'smooth'});
    }, 200);
  }
}

export const getBase64FromUrl = async (url: string) => {
    const data = await fetch(url);
    const blob = await data.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        const base64data = reader.result;
        resolve(base64data)
      };
    });
  };

export const useConfirmDialog = () => {
  const { create } = useModal();

  async function confirmDialog (message: string): Promise<boolean> {
    try {
      const result = await create({
        title: 'Confirmation',
        slots: {
          default: () => h('div', { innerHTML: message })
        },
        okTitle: 'Oui',
        okClass: 'order-first',
        cancelTitle: 'Non',
        centered: true,
        noCloseOnBackdrop: true,
        noCloseOnEsc: true,
        noHeader: true
      }).show();

      return result && typeof result === 'object' && 'ok' in result ? result.ok === true : false;
    } catch {
      return false;
    }
  };

  return {
    confirmDialog
  };
};

export const formatDate = (date: Date | string | null | undefined, format: string) : string => {
  if(!date) return '';
  return dayjs(date).format(format);
}

export const formatDatePeriod = (start?: Date, end?: Date, withPrefix = true): string => {
  if (!start || !end) return '';
  const fmtMonth = (d: Date, withDay = true) =>
    (withDay ? formatDate(d, 'D') + ' ' : '') + capitalizeFirstLetter(formatDate(d, 'MMMM'));
  const endFull = `${fmtMonth(end)} ${formatDate(end, 'YYYY')}`;
  if (start.toDateString() === end.toDateString()) return `${withPrefix ? 'Le ' : ''}${endFull}`;
  const sameMonth = start.getMonth() === end.getMonth();
  const startPart = sameMonth ? formatDate(start, 'D') : fmtMonth(start);
  return `${withPrefix ? 'Du ' : ''}${startPart} au ${endFull}`;
}

export const capitalizeFirstLetter = (text?: string) : string => {
  if (!text) return '';
  return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
}

export const GetCompanionLabel = (label?: string | null, count = 1, capitalize = false): string => {
  const normalizedLabel = label?.trim() || 'accompagnant';
  const pluralizedLabel = count === 1 || normalizedLabel.toLowerCase().endsWith('s')
    ? normalizedLabel
    : `${normalizedLabel}s`;

  return capitalize
    ? pluralizedLabel.charAt(0).toUpperCase() + pluralizedLabel.slice(1)
    : pluralizedLabel;
}

export const truncate = (text: string, length: number = 50) : string => {
  if (!text) return '';
  if (text.length <= length) return text;
  return text.substring(0, length) + '...';
}

export const getPictureUrl = (key: string, maxHeight?: number, maxWidth?: number, roundBorder?: boolean) : string => {
  return `${import.meta.env.VITE_API_ENDPOINT}/file/${key}/preview?maxHeight=${maxHeight ? maxHeight * 1.5 : ''}&maxWidth=${maxWidth ? maxWidth * 1.5 : ''}&roundBorder=${roundBorder ? 'true' : 'false'}`;
}

export const getFileUrl = (key: string, forceDownload: boolean = false) : string => {
  return `${import.meta.env.VITE_API_ENDPOINT}/file/${key}${forceDownload ? '?forceDownload=true' : ''}`;
}

export const hasOnlyTags = (str: string) : boolean => {
  return str.replace(/<(?!img)[^>]*>/g, '').trim() === '';
}

export const normalizeRichTextContent = (html?: string | null): string => {
  if (!html) return '';

  return html
    .replace(/&nbsp;/g, " ")
    .replace(/\( /g, "(&nbsp;").replace(/ \)/g, "&nbsp;)") // Add non-breaking space around parentheses
    .replace(/\u00A0/g, " ")
    .replace(/<p(\s[^>]*)?>\s*<\/p>/g, "<p$1><br></p>");
}

export const getAdminWebInscriptionUrl = (travelId: number, userId: number, forceDownload: boolean = false) : string => {
  return `${import.meta.env.VITE_API_ENDPOINT}/admin/exports/travel/${travelId}/participant/${userId}/web_inscription?${forceDownload ? 'forceDownload=true' : ''}`;
}

export const formatNameToHtml = (text?: string | null): string => {
  if (!text) return '';
  return text
    // For transport
    .replace(/\(\s*eco\s*\)/gi, '<span class="fw-normal fst-italic">$&</span>')
    .replace(/\(\s*economy\s*\)/gi, '<span class="fw-normal fst-italic">$&</span>')
    .replace(/\(\s*economie\s*\)/gi, '<span class="fw-normal fst-italic">$&</span>')
    .replace(/\(\s*premium\s*\)/gi, '<span class="fw-normal fst-italic">$&</span>')

    .replace(/\(\s*avec escale\s*\)/gi, '<span class="fw-normal fst-italic">$&</span>')
    .replace(/\(\s*escale\s*\)/gi, '<span class="fw-normal fst-italic">$&</span>')

    // For Hotel Room
    .replace(/\(\s*[^)]*m²\s*\)/gi, '<small class="fw-normal fst-italic text-lowercase">$&</small>');
}

export const isBoolSetting = (setting: UserSetting): boolean => {
  switch (setting.key) {
    case SettingKeyEnum.MODE_BETA:
      return true;
    default:
      return false;
  }
}

export const formatPrice = (price: number): string => {
  if (price === 0) return 'Inclus';
  const formattedPrice = Math.abs(price).toLocaleString('fr-FR');
  return price > 0 ? `+ ${formattedPrice} €` : `- ${formattedPrice} €`;
};

export const formatPriceWithoutPlusSign = (price: number): string => {
  if (price === 0) return 'Inclus';
  const formattedPrice = Math.abs(price).toLocaleString('fr-FR');
  return price > 0 ? `${formattedPrice} €` : `- ${formattedPrice} €`;
};

export const countRooms = (rooms: ParticipationDbHotelRoom[]): number => {
  let roomCounts = 0;
  for (const room of rooms) {
    if (room.type === TravelDbHotelRoomTypeEnum.Twin && room.roommates?.every(r => r.userDbId != null)) roomCounts += 0.5;
    else roomCounts += 1;
  }

  return Math.ceil(roomCounts);
};
